import styles from "./auth0-imitation.module.scss";

export const Auth0CardBody: React.FC = ({ children }) => {
  return <div className={styles.auth0Body}>{children}</div>;
};
